<template>
  <FilterComponent :header="t('message.filter')" @reset="clearAllFilters()">
    <template v-for="[fieldName, columnDefinition] in filterableColumns" :key="fieldName">
      <slot :name="fieldName" :column-definition="columnDefinition" :field-name="fieldName" :schema="schema" :query="query">
        <div v-if="columnDefinition" class="mb-4 flex w-full flex-col rounded-md border p-2">
          <TableFilterHeadCell
            v-model="query.sorting"
            :text="columnDefinition.columnName"
            :should-fill-column="columnDefinition.shouldFillColumn"
            :field-name="fieldName"
            :format="schema.fields[fieldName].format"
            :is-sortable="columnDefinition.isSortable"
          >
            <FilterButton
              v-model:filters="query.filters[fieldName]"
              class="invert dark:invert-0"
              :format="schema.fields[fieldName].format"
            >
            </FilterButton>

            <SortingIcon v-model="query.sorting" class="invert dark:invert-0" :field="String(fieldName)"> </SortingIcon>
          </TableFilterHeadCell>
          <div>
            <div class="mt-1 flex flex-col gap-1">
              <slot :name="`content-${fieldName}`">
                <FilterFactoryComponent
                  v-if="query.filters[fieldName] !== undefined"
                  v-model="query.filters[fieldName]"
                  :field-definition="schema.fields[fieldName]"
                  :column-name="columnDefinition.columnName"
                ></FilterFactoryComponent>
              </slot>
            </div>
          </div>
        </div>
      </slot>
    </template>
  </FilterComponent>
</template>

<script setup lang="ts" generic="T extends GenericTableSchema">
import { useI18n } from "vue-i18n";
import FilterComponent from "../../../../components/FilterComponent.vue";
import { GenericTableColumnDefinitions } from "../../type.genericTableColumnDefinition";
import { GenericTableQuery } from "../../type.genericTableQuery";
import { GenericTableSchema } from "../../type.genericTableSchema";
import FilterFactoryComponent from "../filters/FilterFactoryComponent.vue";
import FilterButton from "./FilterButton.vue";
import SortingIcon from "./SortingIcon.vue";
import TableFilterHeadCell from "./TableFilterHeadCell.vue";
const { t } = useI18n();

const query = defineModel<WithRequiredProperty<GenericTableQuery<T>, "filters" | "pagination" | "search" | "sorting">>({
  required: true,
});
const props = defineProps<{
  schema: T;
  columnDefinitions: GenericTableColumnDefinitions<T>;
}>();

const filterableColumns = Object.entries(props.columnDefinitions).filter(
  ([, fieldDefinition]) => fieldDefinition && fieldDefinition.isFilterable,
);

function clearAllFilters() {
  const filters = query.value.filters;
  if (!filters) return;
  for (const { filter } of Object.values(filters)) {
    filter.value = undefined;
  }
  query.value.sorting = [];
}
</script>
